export default __webpack_public_path__ + "static/media/JungleLife_08.41c266e2.png";